import {
    Modal, Button, ModalHeader, ModalBody, ModalFooter, Badge,
} from 'appkit-react';

import '../styles/resetWarningModal.scss';

const ResetWarningModal = ({
    showWarningModal, setShowWarningModal, setConfirmReset,
}) => (
    <div className="true-comply__datarecon-dataconfiguration-reset_warning_modal">
        <Modal
            className="action-modal-showcase"
            visible={showWarningModal}
            onCancel={() => setShowWarningModal(false)}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <Badge className="example-badge" type="warning">WARNING</Badge>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <div
                    className="true-comply__datarecon-dataconfiguration-reset_warning_modal_description"
                >
                    This action will clear the flow you have created. Are you sure you want to proceed ?
                </div>
            </ModalBody>
            <ModalFooter className="a-apply-theme-border-top-gray-level-6">
                <div className="button-comp">
                    <Button
                        kind="transparent"
                        gray
                        onClick={
                            () => {
                                setConfirmReset(false);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        NO
                    </Button>
                    <Button
                        kind="transparent"
                        onClick={
                            () => {
                                setConfirmReset(true);
                                setShowWarningModal(false);
                            }
                        }
                        size="lg"
                    >
                        YES
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    </div>
);

export default ResetWarningModal;
